<template>
	<v-flex xs12>
		
		<v-container>
			<Upload 
			upload="files/uploadSeasonVideo"
			replace-method="files/replaceSeasonVideo"
			cancel-method="files/cancelSeasonVideoReplace"
			:max-files="4"
			
			validate-method="checkpointsValidator/validateSeasonVideoTask"
			></Upload>
		</v-container>
		<v-container>
			<SeasonVideoAnswers></SeasonVideoAnswers>
		</v-container>
		<v-container>
			<v-card-actions>
			        	<!--v-btn :disabled="!valid" @click="store()" small color="success">
			        		<v-icon>save</v-icon>
			        		{{translater.__('Save')}}
			        	</v-btn-->
						<SuccessButton :valid="valid" :onClick="store"></SuccessButton>
			        	<!--v-btn @click="add = false" small color="error">
			        		<v-icon>cancel</v-icon>
			        		{{translater.__('Cancel')}}
			        	</v-btn-->
						<ErrorButton :onClick="() => add = false"></ErrorButton>
			        </v-card-actions>
		</v-container>
	</v-flex>
</template>

<script>
	import Upload from './Upload'
	import SeasonVideoAnswers from './SeasonVideoAnswers';
	import SuccessButton from '../../../common/components/SuccessButton';
	import ErrorButton from '../../../common/components/ErrorButton'

	export default {
		name: 'SeasonVideoTask',
		components: {
			Upload,
			SeasonVideoAnswers,
			SuccessButton,
			ErrorButton
		},

		computed: {

			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			add: {
				get()
				{
					return this.$store.getters['checkpoints/add']
				},

				set(value)
				{
					this.$store.dispatch('checkpoints/setAddCheckpoint', value)
				}

			},

			valid: {
				get()
				{
					return this.$store.getters['checkpointsValidator/isValid']
				}
			}
		},

		methods: {
			store()
			{
				this.$store.dispatch('checkpoints/storeSeasonVideoTask');
			}
		}

		
	}
</script>